// @flow
import type { EntityRecordI } from './EntityRecord';
import EntityRecord from './EntityRecord';
import { States } from 'shared/constants/states';

const { REACT_APP_TRAINING_APP_URL: firearmsTrainingUrl = '' } = process.env;

// Run after each response; they can arrive in any order
export const withOriginatingSiteUrl = (
  record: EntityRecordI
): EntityRecordI => {
  // Retail partner URLs come from the course
  if (record.isRetailPartner) {
    return record;
  }

  const stateSlug = States.find((s) => s.abbreviation === record.state)?.slug;
  const { instructorSlug, occurrenceSlug } = record;

  if (!stateSlug || !instructorSlug || !occurrenceSlug) {
    return record;
  }

  // $FlowFixMe
  return new EntityRecord({
    ...record.toJS(),
    originatingSiteUrl: `${firearmsTrainingUrl}/instructors/${stateSlug}-instructors/${instructorSlug}/${occurrenceSlug}/`
  });
};
